import type { AssetDetails } from 'modules/queries/asset/useDetails';
import getAssetsNewOrderedAddOns from './getAssetsNewOrderedAddOns';
import useNewOrderedAddOns from './useNewOrderedAddOns';

/**
 * Lists the add-ons ordered for one server that the server does not list yet.
 * A server lists an Acronis backup in its backups and storage details and every
 * other add-on in its association details. `isLoading` stays true until the
 * ordered add-ons have loaded.
 */
const useAssetNewOrderedAddOns = (
	asset?: Pick<
		AssetDetails,
		'uniq_id' | 'associationDetails' | 'backupsAndStorage' | 'hasAcronis'
	>,
) => {
	const { newOrderedAddOns, isLoading } = useNewOrderedAddOns();

	return {
		assetNewOrderedAddOns: getAssetsNewOrderedAddOns(
			newOrderedAddOns,
			asset ? [asset] : [],
		),
		isLoading,
	};
};

export default useAssetNewOrderedAddOns;
